import DataTableContainer from '../../dashboards/data-table-container';
import { TrackingDataTable } from './components/tracking-data-table';

export const TrackingSection = () => {
  return (
    <DataTableContainer>
      <TrackingDataTable />
    </DataTableContainer>
  );
};
